import React, { useContext, useEffect, useRef, useState } from "react";
import { Avatar, Badge, Box, Button, Grid, Typography } from "@mui/material";
import { userService } from "../../services/auth";
import { UserTypeContext } from "../../context/userStatus";
import { baseEndpoints, xVersion } from "../../services/config";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";
import ZapIcon from "../../assets/images/icon/Zap";
import ArchiveIcon from "../../assets/images/icon/ArchiveIcon";
import Foldericon from "../../assets/images/icon/FolderIcon";
import BellIcon from "../../assets/images/icon/BellIcon";
import PlaneIcon from "../../assets/images/icon/PlaneIcon";
import { ReportsTypeContext } from "../../context/userIReports";
import { setWeekReport } from "../../store/actions/reportTypeAction";
import Htmltoolip from "../../components/HTMLTooltip";
import moment from "moment"
import { useNavigate } from "react-router-dom";
import HTMLTooltip from "../../components/HTMLTooltip";
import { pxToRem } from "../../theme/typography";
import { setOpenSubscriptionModal, setUserObject, setUserProducts } from "../../store/actions/userTypeAction";
import { UserNotificationContext } from "../../context/userNotification";
import {
  setAnchor,
  setXPos,
  setYPos,
  updateNotificationData,
  updateUnreadNotificationData,
} from "../../store/actions/notificationActions";
import HeaderPopover from "./HeaderPopover";
import { notificationService } from "../../services/notifications";
import palette from "../../theme/palette";
import StrikeIcon from "../../assets/images/icon/StrikeIcon";
import TrackTitle from "./TrackTitle";
import CommonTypo from "../../components/CommonTypo";
import PaymentPlanInfo, { PAYMENT_STATUS } from "../trackerNewV2/paymentplaninfo";
import NewButton from "../../components/NewButton";
import EyeIcon from "../../assets/images/icon/EyeIcon";
import AccountRestrictionTimeout from "../../components/AccountRestrictionTimeout";
import StrikeIconV2 from "../../assets/images/icon/StrikeIconV2";
import HeartBlank, { HeartBlankV2 } from "../../assets/images/icon/HeartBlank";
import dayjs from "dayjs";
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 0,
    top: 0,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 2px",
    fontSize: "0.50rem",
  },
}));
const DummyUser = require("../../assets/images/userDummy.png");
const useStyles = makeStyles((theme) => ({
  headerGrid: {
    padding: "20px 20px 0px 24px",
    alignItems: "center",
    gap: "48px",
  },
  headerNameGrid: {},
  headerTiele: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  icons: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
  },
  rectange: {
    width: "1px",
    height: "24px",
    background: "#A0A0A1",
  },
  button: {
    display: "flex",
    padding: "15px 16px 15px 15px",
    alignItems: "center",
    gap: "6px",
    borderRadius: "100px",
    background: "#11734A",
  },
  iconRound: {
    display: "flex",
    width: "24px",
    height: "24px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "100px",
    // border: "1px solid #F3F3F3",
    // background: "#FFF",
  },
  iconStreak: {
    width: "56px",
    height: "46px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"

  },
  iconRoundCustom: {
    display: "flex",
    // width: "44px",
    height: "32px",
    alignItems: "center",
    gap: "4px",
    borderRadius: "100px",
    // border: "1px solid #F3F3F3",
    // background: "#FFF",
  },
  headerGridChild: {
    // "@media  (min-width: 1200px) ": {
    //     flexBasis: "56.25%",
    //     flexGrow: 0,
    //     maxWidth: "56.25%",
    // },
    // "@media  (min-width: 900px) ": {
    //     flexBasis: "56.25%",
    //     flexGrow: 0,
    //     maxWidth: "56.25%",
    // },
    // "@media  (min-width: 600px) ": {
    //     flexBasis: "56.25%",
    //     flexGrow: 0,
    //     maxWidth: "56.25%",
    // },
  },
  headerGridChild6: {
    // "@media  (min-width: 1200px) ": {
    //     flexBasis: "14.5% !important",
    //     flexGrow: 0,
    //     maxWidth: "14.5% !important",
    // },
    // "@media  (min-width: 900px) ": {
    //     flexBasis: "37.5%",
    //     flexGrow: 0,
    //     maxWidth: "37.5%",
    // },
    // "@media  (min-width: 600px) ": {
    //     flexBasis: "37.5%",
    //     flexGrow: 0,
    //     maxWidth: "37.5%",
    // },
  },
}));

const TrackHeader = (props: any) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { isDarkMode = false } = props;
  const [ImageFile, setImageFile] = useState(null);
  const [Uploaded, setUploaded] = useState(false);
  const { state: outcomeState, dispatch: userTypeDispatch } =
    useContext(UserTypeContext);
  const { dispatch: reportTypeDispatch } = useContext(ReportsTypeContext);
  const { state: INotificationState, dispatch: notificationDispatch } =
    useContext(UserNotificationContext);
  const { alreadyCalled, notifications, unreadnotifications } =
    INotificationState;
  const [userDetails, setUserDetails] = useState<any>(outcomeState.userDetails);

  const [trackQuoteData, setTrackQuoteData] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(PAYMENT_STATUS.ONBOARD);
  const [subscriptionPlanEnded, setSubscriptionPlanEnded] = useState(false);
  const [subscriptionPlanEndedBilling, setSubscriptionPlanEndedBilling] = useState(false);
  const [visiblePaymentFree, setVisiblePaymentFree] = useState(false);
  let userValues = JSON.parse(localStorage.getItem("userValues"));
  const hiddenFileInput = React.useRef(null);
  useEffect(() => {
    if (
      !userDetails ||
      !Object.keys(userDetails) ||
      !Object.keys(userDetails).length
    ) {
      getUserDetails();
      getAvailablePlans()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outcomeState.userDetails]);
  useEffect(() => {
    if (
      userDetails && userDetails?.streakDays !== outcomeState.userDetails?.streakDays
    ) {
      setUserDetails(outcomeState.userDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outcomeState.userDetails]);
  useEffect(() => {
    if ((!notifications || !notifications.length) && !alreadyCalled) {
      notificationService
        .getNotificationList(outcomeState.token)
        .then((res) => {
          notificationDispatch(updateNotificationData(res?.notificationData));
          notificationDispatch(updateUnreadNotificationData(res?.unread));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          // this.setState({
          //   buttonLoading: false
          // })
          // this.openCloseEditGoalModal(false)
        });
    }
  }, [alreadyCalled]);
  useEffect(() => {
    const trackQuote = localStorage.getItem("trackQuote")
    if (
      outcomeState?.journeyList &&
      outcomeState?.journeyList?.trackQuoteData &&
      outcomeState?.journeyList?.trackQuoteData[0] &&
      outcomeState?.journeyList?.trackQuoteData[0]?.title &&
      !trackQuoteData
    ) {
      if (trackQuote) {
        setTrackQuoteData(trackQuote);
      } else {
        localStorage.setItem("trackQuote", outcomeState?.journeyList?.trackQuoteData[0]?.title)
        setTrackQuoteData(outcomeState?.journeyList?.trackQuoteData[0]?.title);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outcomeState?.journeyList?.trackQuoteData]);
  const { streakDays = 0 } = userDetails

  const renderIcon = (
    icon,
    onClick = (val: any) => { },
    ref = null,
    customValue = undefined
  ) => (
    <div
      className={
        Number(customValue) >= 0 ? classes.iconRoundCustom : classes.iconRound
      }
      onClick={onClick}
      ref={ref}
    >
      {Number(customValue) >= 0 && (
        <Typography
          sx={{
            color: "var(--color-text-primary) !important",
            fontSize: "14px !important",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "16.8px",
          }}
        >
          {customValue} days
        </Typography>
      )}
      {icon}{" "}

    </div>
  );
  const renderIconStreak = (
    onClick = (val: any) => { },
    ref = null,
    customValue = undefined,
    hearts = 0
  ) => (
    <div
      className={classes.iconStreak}
      onClick={onClick}
      ref={ref}
    >
      <Box display={"flex"} alignItems={"center"} gap={"4px"} height={"32px"}>
        <StrikeIconV2 />
        <CommonTypo size={20} fontWeight={600} lineHeight={22} color="var(--color-text-primary)">{customValue}</CommonTypo>
      </Box>
      <Box display={"flex"} alignItems={"center"} height={"14px"}>
        {[1, 2, 3, 4].map(it => <HeartBlankV2 key={it} filled={it <= hearts} />)}
      </Box>
    </div>
  );
  const getAvailablePlans = () => {
    const token = localStorage.getItem("userDetails")
    userService
      .getAllPlans(token)
      .then((data: any) => {
        console.log("data", data.data.data);
        userTypeDispatch(
          setUserProducts(data.data.data)
        );
      })
      .catch((error) => {
        console.log("User profile Error");
      });
  }
  const getUserDetails = () => {
    const userId = {
      uid: outcomeState?.userId
        ? outcomeState?.userId
        : userValues?.uid
          ? userValues?.uid
          : localStorage.getItem("userId"),
    };
    userService
      .getUserById(userId)
      .then((data: any) => {
        console.log("getUserById data", data);
        
        userTypeDispatch(setUserObject({
          ...data?.data,
          userSubscriptionStatus: data.userSubscriptionStatus,
          userAccountStatus: data?.userAccountStatus,
          formatHolidayEndDate: data?.formatHolidayEndDate,
          formatHolidayStartDate: data?.formatHolidayStartDate,
          holidayMode: data?.holidayMode
        }));
        if (
          outcomeState.userDetails &&
          Object.keys(outcomeState.userDetails).length
        ) {
          setUserDetails(data?.data);
        }
        data?.data?.imageUrl !== "Not Updated"
          ? setImageFile(data?.data?.imageUrl)
          : setImageFile(null);
        localStorage.setItem("userValues", JSON.stringify(data?.data));
        localStorage.setItem("userDate", JSON.stringify(data?.data?.createdAt));
        // if (!props.isTracking) {
        //   if (!data.data.onboardedDate) {
        //     setPaymentStatus(PAYMENT_STATUS.ONBOARD)
        //     setVisiblePaymentFree(true)
        //   }
        //   if (["FREE_PLAN_END"].includes(data.userSubscriptionStatus)) {
        //     setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V2)
        //     setVisiblePaymentFree(true)
        //   }
        //   if (["SUBSCRIPTION_END"].includes(data.userSubscriptionStatus)) {
        //     setPaymentStatus(PAYMENT_STATUS.SUBSCRIPTION_ENDED)
        //     setVisiblePaymentFree(true)
        //   }
        // }


      })
      .catch((error) => {
        console.log("User profile Error");
      });
  };
  const gotoWooklyProgress = () => {
    reportTypeDispatch(setWeekReport(true));
    navigate("/progress/weekly");
  };
  const gotoArchiveMode = () => {
    // reportTypeDispatch(setWeekReport(true));
    navigate("/archive");
  };
  const popRef: any = useRef();
  const handleClickPopover = (event) => {
    if (popRef?.current) {
      notificationDispatch(
        setXPos(popRef?.current?.getBoundingClientRect().left)
      );
      notificationDispatch(
        setYPos(popRef?.current?.getBoundingClientRect().top + 40)
      );
      notificationDispatch(setAnchor(event.currentTarget));
    }
  };
  const userNamerender = (name = "") => {
    const arr = name.split(" ");
    const stringArrr = [];
    for (var i = 0; i < arr.length; i++) {
      stringArrr.push(arr[i].charAt(0).toUpperCase());
    }
    return stringArrr.join("");
  };
  const { holidayMode = "OFF", formatHolidayEndDate = null, formatHolidayStartDate = null } = outcomeState?.userDetails || {}
  let holidayModeOnAndBetweenDate = false
  if (holidayMode === "ON" && formatHolidayEndDate && formatHolidayStartDate) {
    const today = moment().startOf("day")
    if ([moment(formatHolidayStartDate, "MM-DD-YYYY").format("MM/DD/YYYY"), moment(formatHolidayEndDate,  "MM-DD-YYYY").format("MM/DD/YYYY")].includes(today.clone().format("MM/DD/YYYY"))) {
      holidayModeOnAndBetweenDate = true
    }
    if (today.clone().isSameOrAfter(moment(formatHolidayStartDate, "MM-DD-YYYY")) && today.clone().isSameOrBefore(moment(formatHolidayEndDate,  "MM-DD-YYYY"))) {
      holidayModeOnAndBetweenDate = true
    }
  }
  return (
    <>
      <Grid
        container
        columns={16}
        sx={{
          flexWrap: "nowrap !important",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className={classes.headerGrid}
      >
        <Grid
          item
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={"16px"}
          className={classes.headerGridChild}
        >
          {props.settings && props.isFaq && (
            <CommonTypo size={24} fontWeight={700} lineHeight={28.8} color="var(--color-text-primary)">F.A.Q</CommonTypo>
          )}
          {props.settings && !props.isFaq && (
            <CommonTypo size={24} fontWeight={700} lineHeight={28.8} color="var(--color-text-primary)">Settings</CommonTypo>
          )}
          {/* {props.isProgress ? (
          <div className={classes.headerTiele}>
            <Typography
              sx={{
                color: "var(--color-black)",
                fontSize: "32px !important",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "100%",
              }}
            >
              Progress
            </Typography>
          </div>
        ) : ( */}
          {!props.settings && (
            <>
              {userDetails.imageUrl && userDetails.imageUrl !== "Not Updated" ? (
                <img
                  alt="user"
                  src={
                    userDetails.imageUrl
                      ? outcomeState?.outcomePopup?.isUploaded
                        ? URL.createObjectURL(outcomeState?.outcomePopup?.image)
                        : `${baseEndpoints.getImage}${userDetails.imageUrl}`
                      : DummyUser
                  }
                  style={{
                    height: 48,
                    width: 48,
                    borderRadius: "44px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate('/profile')}
                />
              ) : (
                <Avatar
                  sx={{
                    width: "48px",
                    height: "48px",
                    background: "var(--color-new-main)",
                    fontSize: "16px",
                    cursor: "pointer"
                  }}
                  onClick={() => navigate('/profile')}
                >
                  {userNamerender(
                    userDetails?.first_name + " " + userDetails?.last_name
                  )}
                </Avatar>
              )}
              <div className={classes.headerTiele}>
                <Typography
                  sx={{
                    color: "var(--color-black)",
                    fontSize: "24px !important",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "28.8px",
                  }}
                >
                  Hi, {userDetails?.first_name}
                </Typography>
                <Typography
                  id="track-quote"
                  sx={{
                    color: "var(--color-black)",
                    fontSize: "12px !important",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "14.4px",
                  }}
                >
                  {trackQuoteData}
                </Typography>
              </div>
            </>
          )}
          {/* )} */}

        </Grid>
        <Grid
          item
          display={"flex"}
          gap={"16px"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          className={classes.headerGridChild6}
        >
          <div className={classes.icons}>
            {outcomeState.restrictUser &&
              <Box display={"flex"} alignItems={"center"} gap={"8px"}>
                <NewButton
                  buttonText={<>
                    <EyeIcon color="var(--color-text-primary)" />
                    <CommonTypo size={16} lineHeight={24} color="var(--color-text-primary)">View Only</CommonTypo>
                  </>}
                  onClick={() => { }}
                  extraSx={{
                    width: "max-content",
                    background: "var(--color-border)",
                    border: `none`,
                    height: "42px",
                    padding: "8px 16px !important",
                    borderRadius: "12px !important",
                    "&:hover": {
                      background: "var(--color-border)",
                      boxShadow: "none"
                    }
                  }}
                  boxSx={{
                    padding: 0
                  }}
                  typographySx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    "&.MuiTypography-root": {
                      "@media  (max-width: 726px) and (min-width: 100px)": {
                        fontSize: `${pxToRem(16)} !important`,
                        lineHeight: "100% !important",
                        fontWeight: 600,
                        color: "var(--color-text-primary)"
                      },
                    },
                  }}
                />
                <NewButton
                  buttonText={<>
                    <CommonTypo size={16} lineHeight={24} fontWeight={600} color="var(--color-text-primary)">Upgrade Plan</CommonTypo>
                  </>}
                  onClick={() => userTypeDispatch(setOpenSubscriptionModal(true))}
                  extraSx={{
                    width: "max-content",
                    background: "var(--color-new-main)",
                    border: `none`,
                    height: "42px",
                    padding: "8px 16px !important",
                    borderRadius: "12px !important",
                    "&:hover": {
                      background: "var(--color-new-main)",
                      boxShadow: "none"
                    }
                  }}
                  boxSx={{
                    padding: 0
                  }}
                  typographySx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    "&.MuiTypography-root": {
                      "@media  (max-width: 726px) and (min-width: 100px)": {
                        fontSize: `${pxToRem(16)} !important`,
                        lineHeight: "100% !important",
                        fontWeight: 600,
                        color: "var(--color-text-primary)"
                      },
                    },
                  }}
                />
              </Box>

            }
            {outcomeState.restrictUser &&
              <Box borderRadius={"12px"} border={"1px solid var(--color-border)"} padding={"16px"} display={"flex"} flexDirection={"column"} gap={"8px"}>
                <CommonTypo size={12} lineHeight={18} fontWeight={400} color="var(--color-text-primary)" extraSx={{
                  whiteSpace: "nowrap",
                  wordBreak: "keep-all"
                }}>Time until we delete your data:</CommonTypo>
                <CommonTypo size={18} lineHeight={20} fontWeight={600} color="var(--color-text-primary)" extraSx={{
                  whiteSpace: "nowrap",
                  wordBreak: "keep-all"
                }}><AccountRestrictionTimeout /></CommonTypo>
              </Box>
            }
            {!outcomeState.restrictUser && !holidayModeOnAndBetweenDate &&
              <HTMLTooltip
                customIcon={renderIconStreak(
                  () => null,
                  null,
                  userDetails?.streakDays,
                  userDetails?.hearts,
                )}
                title="Strike"
                fontProps={{
                  fontSize: `${pxToRem(12)} !important`,
                }}
                sx={{
                  "& .MuiTooltip-tooltip": {
                    maxWidth: "300px",
                  },
                }}
              />
            }
            {!outcomeState.restrictUser && holidayModeOnAndBetweenDate &&
              <Box display={"flex"} alignItems={"center"} gap={"4px"}>
                <Box display={"flex"} alignItems={"flex-start"} flexDirection={"column"}>
                  <CommonTypo size={16} fontWeight={600} lineHeight={20} color="var(--color-text-primary)">Holiday mode</CommonTypo>
                  <CommonTypo size={12} fontWeight={400} lineHeight={24} color="var(--color-text-secondary)">until {moment(formatHolidayEndDate,  "MM-DD-YYYY").format("DD.MM.YYYY")}</CommonTypo>
                </Box>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.6285 22.2031C22.5361 22.3185 22.422 22.4146 22.2925 22.4858C22.1631 22.5571 22.0209 22.6021 21.874 22.6184C21.7271 22.6347 21.5785 22.6219 21.4366 22.5807C21.2947 22.5395 21.1623 22.4708 21.0469 22.3784C21.015 22.3531 17.4975 19.625 12 19.625C6.50253 19.625 2.98409 22.3531 2.94941 22.3803C2.71618 22.5668 2.41843 22.653 2.12165 22.6199C1.82488 22.5869 1.55339 22.4373 1.36691 22.2041C1.18043 21.9708 1.09423 21.6731 1.12728 21.3763C1.16034 21.0795 1.30993 20.808 1.54316 20.6216C1.69503 20.4997 5.06534 17.8531 10.5291 17.4341C10.3047 16.3693 10.2318 15.2782 10.3125 14.1931C10.4691 12.2441 11.2388 9.70156 13.7813 7.65125C13.5732 7.63083 13.364 7.62363 13.155 7.62969C11.5425 7.68219 10.5666 8.60188 10.0857 10.5247C10.0247 10.7668 9.88494 10.9817 9.6884 11.1357C9.49185 11.2896 9.24969 11.3738 9.00003 11.375C8.90773 11.3752 8.81576 11.3639 8.72628 11.3413C8.43689 11.2689 8.18809 11.0845 8.03461 10.8287C7.88113 10.5729 7.83553 10.2666 7.90784 9.97719C8.32597 8.30938 9.55409 5.49406 13.0885 5.38344C13.5529 5.37118 14.0174 5.40257 14.476 5.47719C14.1507 5.01875 13.7438 4.61375 13.2497 4.40938C12.4735 4.08781 11.4938 4.28469 10.3378 4.99344C10.2117 5.07069 10.0715 5.12234 9.92533 5.14542C9.77918 5.1685 9.62991 5.16257 9.48605 5.12797C9.3422 5.09336 9.20656 5.03076 9.0869 4.94374C8.96723 4.85672 8.86588 4.74698 8.78862 4.62078C8.71137 4.49459 8.65973 4.35442 8.63665 4.20827C8.61356 4.06212 8.61949 3.91285 8.6541 3.76899C8.6887 3.62514 8.7513 3.4895 8.83833 3.36984C8.92535 3.25017 9.03509 3.14882 9.16128 3.07156C10.9707 1.96156 12.6403 1.71219 14.1235 2.33188C15.1041 2.74156 15.9638 3.54313 16.6313 4.66438C17.1807 3.99031 17.8238 3.5225 18.525 3.29469C20.0644 2.79313 21.4969 3.52625 22.4278 4.23219C22.5493 4.31989 22.6521 4.43097 22.73 4.55891C22.808 4.68685 22.8596 4.82907 22.8819 4.97723C22.9041 5.12539 22.8965 5.2765 22.8596 5.4217C22.8227 5.5669 22.7571 5.70326 22.6667 5.82277C22.5764 5.94228 22.4631 6.04254 22.3334 6.11767C22.2038 6.19279 22.0605 6.24127 21.9119 6.26025C21.7633 6.27924 21.6123 6.26835 21.468 6.22822C21.3237 6.18809 21.1888 6.11953 21.0713 6.02656C20.341 5.47438 19.7194 5.27656 19.2263 5.43406C18.7978 5.57188 18.4341 5.96563 18.1547 6.38938C18.6895 6.53897 19.2041 6.75271 19.6875 7.02594C21.1388 7.8575 22.875 9.61344 22.875 13.25C22.875 13.5484 22.7565 13.8345 22.5455 14.0455C22.3345 14.2565 22.0484 14.375 21.75 14.375C21.4517 14.375 21.1655 14.2565 20.9545 14.0455C20.7436 13.8345 20.625 13.5484 20.625 13.25C20.625 11.375 20.0503 10.0222 18.9178 9.20469C19.1262 9.9764 19.1727 10.7829 19.0544 11.5734C18.9362 12.3639 18.6557 13.1215 18.2307 13.7984C18.1558 13.9312 18.0548 14.0474 17.9338 14.14C17.8127 14.2325 17.6741 14.2995 17.5263 14.3369C17.3786 14.3742 17.2248 14.3812 17.0743 14.3573C16.9238 14.3334 16.7797 14.2792 16.6507 14.198C16.5218 14.1167 16.4107 14.0101 16.3242 13.8846C16.2378 13.7592 16.1777 13.6174 16.1476 13.468C16.1176 13.3186 16.1182 13.1647 16.1494 13.0155C16.1807 12.8663 16.2419 12.7251 16.3294 12.6003C16.6021 12.1489 16.778 11.6458 16.846 11.1228C16.9566 10.2706 16.7457 9.45313 16.2216 8.68531C14.0082 10.0241 12.7791 11.9066 12.5653 14.2916C12.4815 15.3325 12.5725 16.3801 12.8344 17.3909C18.6685 17.645 22.2947 20.4913 22.4532 20.6178C22.5691 20.7102 22.6656 20.8245 22.7372 20.9543C22.8088 21.0841 22.854 21.2267 22.8703 21.374C22.8866 21.5213 22.8736 21.6704 22.8321 21.8127C22.7906 21.955 22.7214 22.0877 22.6285 22.2031ZM1.87503 14C1.87503 13.4067 2.05098 12.8266 2.38062 12.3333C2.71027 11.8399 3.1788 11.4554 3.72698 11.2284C4.27516 11.0013 4.87836 10.9419 5.4603 11.0576C6.04224 11.1734 6.57679 11.4591 6.99635 11.8787C7.41591 12.2982 7.70163 12.8328 7.81739 13.4147C7.93314 13.9967 7.87373 14.5999 7.64667 15.1481C7.41961 15.6962 7.03509 16.1648 6.54174 16.4944C6.04839 16.8241 5.46837 17 4.87503 17C4.07938 17 3.31632 16.6839 2.75371 16.1213C2.1911 15.5587 1.87503 14.7957 1.87503 14ZM4.12503 14C4.12503 14.1483 4.16902 14.2933 4.25143 14.4167C4.33384 14.54 4.45097 14.6361 4.58802 14.6929C4.72506 14.7497 4.87586 14.7645 5.02135 14.7356C5.16683 14.7067 5.30047 14.6352 5.40536 14.5303C5.51025 14.4254 5.58168 14.2918 5.61062 14.1463C5.63956 14.0008 5.62471 13.85 5.56794 13.713C5.51117 13.5759 5.41504 13.4588 5.29171 13.3764C5.16837 13.294 5.02337 13.25 4.87503 13.25C4.67612 13.25 4.48535 13.329 4.3447 13.4697C4.20405 13.6103 4.12503 13.8011 4.12503 14Z" fill="#3E4240" />
                </svg>
              </Box>
            }
            {!props.settings && !outcomeState.restrictUser && (
              <TrackTitle
                setIsArchiveMode={false}
                isArchiveMode={false}
                createDate={outcomeState.userDetails.createdAt}
              />)}


            {!outcomeState.restrictUser && <HTMLTooltip
              customIcon={renderIcon(
                <StyledBadge
                  color={"primary"}
                  badgeContent={unreadnotifications.length}
                  max={99}
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "var(--color-new-main)",
                      color: isDarkMode ? "var(--white-background)" : "var(--color-black)"
                    },
                  }}
                >
                  <BellIcon />
                </StyledBadge>,
                handleClickPopover,
                popRef
              )}
              title="Notifications"
              fontProps={{
                fontSize: `${pxToRem(12)} !important`,
              }}
              sx={{
                "& .MuiTooltip-tooltip": {
                  maxWidth: "300px",
                },
              }}
            />}
            {!outcomeState.restrictUser && <HTMLTooltip
              customIcon={renderIcon(<ArchiveIcon />, gotoArchiveMode)}
              title="Archive"
              fontProps={{
                fontSize: `${pxToRem(12)} !important`,
              }}
              sx={{
                "& .MuiTooltip-tooltip": {
                  maxWidth: "300px",
                },
              }}
            />}


            {!xVersion && (
              <>
                <HTMLTooltip
                  customIcon={renderIcon(<PlaneIcon />)}
                  title="Vacation mode"
                  fontProps={{
                    fontSize: `${pxToRem(12)} !important`,
                  }}
                  sx={{
                    "& .MuiTooltip-tooltip": {
                      maxWidth: "300px",
                    },
                  }}
                />
              </>
            )}

          </div>
          {!xVersion && (
            <>
              <div className={classes.rectange}></div>
              <Button
                variant="contained"
                sx={{
                  display: "flex",
                  padding: "15px 16px 15px 15px",
                  alignItems: "center",
                  gap: "6px",
                  borderRadius: "100px",
                  background: "#11734A",
                  marginBottom: "0 !important",
                }}
                className={classes.button}
              >
                <ZapIcon />
                Upgrade
              </Button>
            </>
          )}
          <HeaderPopover
            handleClose={() => notificationDispatch(setAnchor(null))}
          />
        </Grid>
      </Grid>
      {visiblePaymentFree && !props.isTracking ? (
        <PaymentPlanInfo
          visiblePaymentInfo={visiblePaymentFree}
          onClose={() => {
            if (!subscriptionPlanEnded) {
              localStorage.removeItem("showPayment")
              setVisiblePaymentFree(false)
            }
          }}
          fixClosePopup={() => {
            setVisiblePaymentFree(false)
            setSubscriptionPlanEndedBilling(true)
          }}
          closeAndOpenRestriction={() => {
            setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V2)
            setVisiblePaymentFree(true)
          }}
          subscriptionPlanEndedBilling={subscriptionPlanEndedBilling}
          subscriptionPlanEnded={subscriptionPlanEnded}
          paymentStatus={paymentStatus}
        />
      ) : null}
    </>
  );
};

export default TrackHeader;
